import { Controller, Control, FieldErrors } from 'react-hook-form';
import { LoanFormData } from '@/schemas/loanSchema';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { getErrorMessage } from '@/components/formErrorMessage';
import { DatePicker } from '@/components/ui/date-picker';

interface Props {
  control: Control<LoanFormData>;
  errors: FieldErrors<LoanFormData>;
}

export const ForbearanceSection = ({ control, errors }: Props) => (
  <div className="p-8 mb-8" data-test-id="forbearance-container">
    <h3 className="section-title">Forbearance</h3>
    <div className="grid-3">
      <div>
        <Label className="form-label" htmlFor="forbearance.forbearance_type">
          Forbearance Type
        </Label>
        <Controller
          name="forbearance.forbearance_type"
          control={control}
          render={({ field }) => (
            <Select onValueChange={field.onChange} value={field.value ?? ''}>
              <SelectTrigger
                error={getErrorMessage(errors, 'forbearance.forbearance_type')}
              >
                <SelectValue placeholder="Select type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="P&I">P&I</SelectItem>
                <SelectItem value="P&I Reduced">P&I Reduced</SelectItem>
                <SelectItem value="Interest Only">Interest Only</SelectItem>
              </SelectContent>
            </Select>
          )}
        />
      </div>
      <div>
        <Label
          className="form-label"
          htmlFor="forbearance.forbearance_payback_start_date"
        >
          Forbearance Payback Start Date
        </Label>
        <Controller
          name="forbearance.forbearance_payback_start_date"
          control={control}
          render={({ field }) => (
            <DatePicker
              value={field.value ? (typeof field.value === 'string' ? field.value : new Date(field.value).toISOString().split('T')[0]) : ''}
              onChange={(val) => field.onChange(val ? new Date(val) : undefined)}
              data-test-id="forbearance-payback-start-date-input"
            />
          )}
        />
      </div>
      <div>
        <Label
          className="form-label"
          htmlFor="forbearance.forbearance_payback_term"
        >
          Forbearance Payback Term
        </Label>
        <Controller
          name="forbearance.forbearance_payback_term"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="number"
              id="forbearance.forbearance_payback_term"
              className="input-full"
              value={field.value ?? ''}
            />
          )}
        />
      </div>
    </div>
  </div>
);
